<template>
  <div>
    <van-loading type="spinner" vertical color="#1989fa">加载中...</van-loading>
  </div>
</template>

<script>
import KWURL from "@/api/kingWaiter";
import URL from "@/api/api";
import { Toast } from "vant";
import { UrlSearch } from "@/utils/utils";
import { jspay2, setSession, setLocal } from '@/utils/utils';
export default {
  data() {
    return {
      productList: [],
      orderNo: '',
      timer: null,
      count: 0
    }
  },
  mounted() {
    console.log('======>mounted')
    this.init();
  },
  methods: {
    init() {
      //先判断是否实名(查询用户信息)，为实名的则跳转至实名认证，然后直接拉起支付页面（查询订单信息），已支付的则跳转至支付列表页面
      console.log('======>init start')
      let that = this
      let orderNo = UrlSearch().orderNo
      let amount = UrlSearch().amount
      let openid = localStorage.getItem("openid") || sessionStorage.getItem("openId")
      let phone = localStorage.getItem("phone");
      if (!orderNo || !openid) {
        that.$router.push("/sharedPayment");
      }
      if (openid && phone) {
        that.qryPayByOrderNo(orderNo, amount);
      } else {
        console.log('======>openid and phone not all have value')
        that.$fetchPost(URL.checkOpenid.url + openid).then((res) => {
          if (res.data.code === 20000) {
            setLocal("isLogin", 1);
            setLocal("phone", res.data.data.phoneNo);
            setLocal("authFlag", res.data.data.authFlag);
            setLocal("buyFlag", res.data.data.buyFlag);
            setSession("user_tel", res.data.data.phoneNo);
            setSession("phoneNumber", res.data.data.phoneNo);
            setSession("phone", res.data.data.phoneNo);
            setLocal("cip", res.data.data.ip);
            //根据订单号，查询订单信息
            that.qryPayByOrderNo(orderNo, amount);
          } else {
            //跳转到实名认证页面
            that.$router.push("/audit");
          }
        });
      }
    },
    qryPayByOrderNo(orderNo, amount) {
      console.log('======>qryPayByOrderNo')
      if (orderNo && amount !== null && amount !== undefined && amount !== 'undefined' && amount !== '') {
        console.log('======>qryPayByOrderNo no')
        let data = {
          openid: localStorage.getItem("openid"),
          phone: localStorage.getItem("phone"),
          ip: localStorage.getItem('cip'),
          money: (amount * 100),
          orderId: orderNo
        }
        jspay2(data)
      } else {
        console.log('======>qryPayByOrderNo yes')
        this.$fetchGet(KWURL.qryPayByOrderNo.url, {orderNo: orderNo, orderFlag: 0}).then(res => {
          if (res.data.code === 20000) {
            let order = res.data.data
            //待支付则拉起支付，其他则跳转到支付列表
            if (order.orderStatus === '0' || order.orderStatus === '2') {
              let data = {
                openid: localStorage.getItem("openid"),
                phone: localStorage.getItem("phone"),
                ip: localStorage.getItem('cip'),
                money: (order.amount * 100),
                orderId: orderNo
              }
              jspay2(data)
            } else {
              this.$router.push("/sharedPayment");
            }
          } else {
            Toast(res.data.msg);
          }
        }).catch(() => {

        });
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .van-loading {
    top: 100px;
  }
</style>
